import React from 'react'
import { useHistory } from 'react-router-dom'

import Page from '../../templates/page'
import Footer from '../../common/footer'

import LastSell from './last-sell'
import SellingPoints from './selling-points'
import Welcome from './welcome'

import { useAuth } from '../../../data/hooks/auth'

const LandingPage: React.FunctionComponent = () => {
    const { user } = useAuth()
    const history = useHistory()

    if (user) {
        history.push('/feed')
    }


    return (
        <Page transparent={true} name={'landing'}>
            <Welcome />
            <SellingPoints />
            <LastSell />
            <Footer />
        </Page>
    )
}

export default LandingPage